import React from 'react'
import { Badge } from 'primereact/badge'
import { Tooltip } from 'primereact/tooltip'

interface StatusBadgeProps {
  status: string
  showTooltip?: boolean
}

export const getStatusSeverity = (status: string) => {
  switch (status.toLowerCase()) {
    case 'unassigned': return 'warning'
    case 'pending': return 'info'
    case 'processing': return 'primary'
    case 'fulfilled': return 'success'
    case 'assigned': return 'info'
    case 'store_declined_order': return 'warning'
    case 'accepted_awaiting_inspection': return 'primary'
    case 'awaiting_shipment': return 'info'
    case 'rejected_by_admin': return 'danger'
    default: return 'info'
  }
}

const getTooltipText = (status: string) => {
  switch (status.toLowerCase()) {
    case 'unassigned': 
      return "Order paid by customer. Needs assignment from admin dashboard."
    case 'assigned':
      return "Store assigned. Awaiting store acceptance and image upload."
    case 'store_declined_order':
      return "Store declined to ship the order with reason."
    case 'rejected_by_admin':
      return "Admin rejected the order with reason."
    case 'accepted_awaiting_inspection':
      return "Order accepted with images uploaded. Awaiting admin inspection."
    case 'awaiting_shipment':
      return "Ready to print shipping label and mark as shipped."
    case 'fulfilled':
      return "Order has been shipped."
    default:
      return ""
  }
}

export const LineItemStatusBadge: React.FC<StatusBadgeProps> = ({ status, showTooltip = true }) => {
  const tooltipText = getTooltipText(status)

  return (
    <span className="status-badge-container" data-pr-tooltip={tooltipText} data-pr-position="right">
      <Badge 
        value={status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
        style={{ whiteSpace: 'nowrap', fontSize: '10px' }}
        severity={getStatusSeverity(status) as 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'contrast' | null}
      />
      {showTooltip && <Tooltip target=".status-badge-container" />}
    </span>
  )
}